import React from "react";

const data = [
  {
    id: "cross-device-rendering",
    title: "Cross-Device Rendering Performance",
    summary: () => (
      <p>
        In collaboration with Freie Universität (FU) Berlin, OHIF 3.14 will
        deliver rendering improvements that make visualization faster, smoother,
        and more reliable across the full range of hardware.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          These improvements span everything from high-end workstations to
          everyday laptops and tablets. This work hardens GPU rendering and adds
          a dependable path for devices where GPU resources are limited, and
          OHIF will automatically select the most appropriate rendering approach
          at runtime so users get consistent performance regardless of their
          device.
        </p>
      </div>
    )
  },
  {
    id: "adaptive-mobile-tablet-ui",
    title: "Adaptive Mobile and Tablet UI",
    summary: () => (
      <p>
        Building on our cross-device rendering work, OHIF 3.14 will introduce an
        interface that adapts gracefully to smaller screens and touch input.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          Beyond the improvements carried over from the FU Berlin collaboration,
          we will undertake a holistic review of the entire viewer to ensure a
          comfortable, consistent experience across all devices.
        </p>
      </div>
    )
  },
  {
    id: "dcmjs-refactor",
    title: "Refactoring dcmjs Library",
    summary: () => (
      <p>
        OHIF 3.14 will include a significant update of dcmjs, the open-source
        library responsible for reading and writing DICOM data across OHIF and
        the wider imaging ecosystem.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          This effort will consolidate and streamline the underlying DICOM
          parsing code, improving performance, maintainability, and long-term
          reliability for the many projects that depend on it.
        </p>
      </div>
    )
  },
  {
    id: "3d-viewport-enhancements",
    title: "3D Viewport Enhancements",
    summary: () => (
      <p>OHIF 3.14 will expand the 3D volume viewport with new tools.</p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          These new tools for working with volumetric data include an intuitive
          orientation controller for quickly reorienting 3D views and volume
          editing tools such as cropping and rendering-quality controls. This
          builds on a community contribution that our team will help carry
          forward through design and implementation.
        </p>
      </div>
    )
  },
  {
    id: "segmentation-import-export",
    title: "Improved Segmentation Import/Export",
    summary: () => (
      <p>
        OHIF 3.14 will make saving, loading, and exporting segmentations faster
        and easier to understand.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          Building on recent work that speeds up DICOM segmentation loading and
          reduces file sizes, we will also redesign the save dialog to clearly
          separate saving to an existing series from creating a new one —
          removing a common point of confusion for clinical users.
        </p>
      </div>
    )
  },
  {
    id: "generic-viewport",
    title: "Generic Viewport in OHIF Viewer",
    summary: () => (
      <p>
        OHIF 3.14 will adopt Cornerstone3D's new generic viewport by default.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          A unified, modern viewport replaces today's separate viewport types
          for stacks, volumes, and other data. It automatically
          adapts to each image type and selects the most efficient rendering
          approach, giving OHIF a cleaner, more consistent, and more performant
          foundation to build on.
        </p>
      </div>
    )
  }
];

export default data;
